<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm :formSchema="formSchema" v-on:emitForm="close" v-if="showForm"></insertForm>

    <v-container>
      <v-card>
        <v-card-title>
          <h2>Asset Category List</h2>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          v-bind:search="search"
          v-bind:pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ (props.index)+1 }}</td>
            <td class="text-xs-left">{{ props.item.cat_name }}</td>
            <td class="text-xs-left">{{ props.item.economic_code }}</td>
            <td class="text-xs-left">{{ props.item.economic_info.eco_account_name }}</td>
            <td class="text-xs-left">{{ (props.item.is_active == 1) ? "Yes" : "No" }}</td>
            <td class="justify-center layout px-0">
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.updateButton"
                @click="editItem(props.index,props.item)"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.deleteButton"
                @click="deleteItem(props.index, props.item.id)"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");
import insertForm from "./asset_cat_form";

export default {
  components: {
    insertForm
  },

  data: () => ({
    // Add edit form controll during user permission
    showForm: false,
    dialog: false,
    totalItems: 0,
    loading: true,

    // DataTable data instance -------------
    pagination: {
      sortBy: "id",
      descending: true
    },
    search: "",

    headers: [
      {
        text: "SL.",
        align: "left",
        sortable: false,
        value: "id"
      },
      {
        text: "Category Name",
        align: "left",
        value: "cat_name"
      },
      {
        text: "Economic Code",
        align: "left",
        value: "economic_info.eco_account_name"
      },
      {
        text: "Economic Code Name",
        align: "left",
        value: "economic_code"
      },
      {
        text: "Active",
        align: "left",
        value: "is_active"
      },
      {
        text: "Action",
        align: "left",
        value: ""
      }
    ],

    items: [],

    queryData: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      search_val: ""
    },

    //Delete data related instance--------
    delete_id: "",
    row_index: "",
    confirmModel: false,

    // snacber script instance ----------
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id: "",
      cat_no: "",
      cat_name: "",
      economic_id: "",
      economic_code: "",
      eco_name: "",
      is_active: 0
    }
  }),

  computed: {
    // User Previlization methods
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    // Table data load reques Methods
    loadData(pagination) {
      commonService.getAllData("asset_category").then(res => {
        this.showForm = this.userRole.saveButton;
        this.items = res.data;
        this.loading = false;
      });
    },

    // Data edit form prepare
    editItem(index, data) {
      // show input form by permission
      this.showForm = true;
      this.formSchema = { ...data };
      this.row_index = index;
      this.formSchema.eco_name = this.formSchema.economic_info.root_name;
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    // data delete confirm modal
    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "asset_category").then(res => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
        }
        this.close(res);
        this.confirmModel = false;
      });
    },

    //  Request response Massage !!!
    close(res) {
      this.showForm = this.userRole.saveButton;
      if (res.status == 1) {
        this.SnackbarVal.color = "success";
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        if (res.action == "add") {
            this.items.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          this.$set(this.items, this.row_index, { ...res.data });
          this.row_index = "";
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth"
        });
      } else {
        this.SnackbarVal.color = "error";
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/asset/asset_category/asset_cat_list.vue